import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal, ModalTitle } from "@vds/modals";
import { Button } from "@vds/buttons";
import { MarginSpacerM } from "../styleTag";
import { TitleLockup } from "@vds3/type-lockups";

const NewCustomerModal = (props) => {
  const { t } = useTranslation(["app"]);

  const newCustomerBtnClicked = () => {
    props.newCustomerBtnClicked();
  };

  const existingCustomerBtnClicked = () => {
    props.existingCustomerBtnClicked();
  };

  return (
    <NCModal
      ariaLabel=""
      opened={props?.showNewCustomerModal}
      onOpenedChange={props?.closeBtnClick}
      disableOutsideClick={true}
      hideCloseButton={true}
      disableFocusLock= {true}
    >
      <ModalTitle>
      <TitleLockup
              data={{
                title: {
                  bold: true,
                  size: "titleLarge",
                  children: t("gridwall-new-existing-modal.heading.new-existing-customer", { ns: "app" }),
                }
              }}
            />
        <MarginSpacerM></MarginSpacerM>
      </ModalTitle>
      <ButtonContainer>
        <Button ClassName="customerButton"
          use="secondary"
          onClick={() => {
            newCustomerBtnClicked();
          }}
        >
          {t("gridwall-new-existing-modal.labels.new-customer", { ns: "app" })}
        </Button>
        <Button className="customerButton"
        use="secondary"
          onClick={() => {
            existingCustomerBtnClicked();
          }}
          secondary={true}
        >
          {t("gridwall-new-existing-modal.labels.existing-customer", {
            ns: "app",
          })}
        </Button>
      </ButtonContainer>
    </NCModal>
  );
};


const NCModal = styled(Modal)`
  height: auto;
  width: 550px;
  min-height: auto;
  outline: none !important;
  overflow: hidden;
  > div:first-child {
    overflow: hidden;
  }
  @media only screen and (max-width:1030px) {
    width:60%
  }  
  @media only screen and (max-width:820px) {
    width:73%
  }  
  @media only screen and (max-width: 767px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95vw;
    > div:first-child {
      padding: 2px;
    }
  }

  @media only screen and (max-width:545px) {    
    bottom: 0px;
    position: fixed;
    top: 0px;
    left: 0px;
    transform:translate(0px,0px);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 25px;
  margin-bottom: 2px;
  column-gap: 10px;
  height:44px;
  span {
    margin-left:15px !important;
    margin-right:15px !important;
  } 
  @media screen and (max-width:767px) {
    position: absolute;
    bottom: 6rem;
    width: 95%;
    padding: 0px;
    margin-left: 0;
    flex-direction: column;
    row-gap: 15px;
    span {
      margin:0px !important;
    }
  }
.customerButton{
  padding: 0 !important;
}  
`;

export default NewCustomerModal;
